import 'core-js/es/symbol/iterator';
import 'typeface-roboto';

import React, { Component } from 'react';
import './App.css';
import Canvas from './canvas';
import {range} from 'd3';
import data from './data.json';
import { colors } from './config.js';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { Select, MenuItem } from "@material-ui/core";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Slider from '@material-ui/lab/Slider';

import IconButton from '@material-ui/core/IconButton';
import PlayIcon from '@material-ui/icons/PlayArrow';
import InfoIcon from '@material-ui/icons/Info';

import PauseIcon from '@material-ui/icons/Pause';
import Button from '@material-ui/core/Button';

import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import logo from './ksh_logo.svg';
import logoEN from './hcso_logo.svg';

import text from './text';

import blue from '@material-ui/core/colors/blue';

const theme = createMuiTheme({
  palette: {
    type: 'light',
    primary: { main: blue[800] },
    secondary: { main: '#11cb5f' },
    text: {
      primary: '#666'
    }
  },
});

class App extends Component {
  getColorByTarget = d => colors[d.targetIndex];
  getColorBySex = d => d.INC1 === 1 ? '#1976d2' : '#f44336';
  createTargetPoints = (width, height) => {
    const cx = width /2,
          cy = height /2,
          margin = 0.2;

    const f = (e, c, t) => Math.round(c + c * t(e / 15 * 2 * Math.PI + Math.PI / 4) * (1 - margin));
    const fx = e => f(e, cx, Math.cos);
    const fy = e => f(e, cy, Math.sin);

    return range(0, 16).map( e => [
      e === 14 ? cx : fx(e > 14 ? e - 1 : e),
      e === 14 ? cy : fy(e > 14 ? e - 1 : e)
    ]);
  }

  state = {
    nodes: data,
    radius: 3,
    time: 6 * 60,
    stopped: false,
    country1: 'HU',
    country2: 'IT',
    getColor: this.getColorByTarget,
    bySex: false,
    width: 0,
    height: 0,
    targetPoints: this.createTargetPoints(0, 0),
    lang: 'HU',
    text: text.HU,
    infoDialog: false
  };

  getSize = () => [
    document.getElementById('compare').offsetWidth / 2,
    document.getElementById('compare').offsetHeight
  ];

  componentDidMount() {
    const lang = window.location.hash === '#en' ? 'EN' : 'HU';
    this.setState({ lang, text: text[lang] });
    document.title = this.state.text.title + ' - ' + this.state.text.KSH;
    setInterval( () => {
      if (this.state.stopped) return;
      const time = this.state.time > 1439 ? 0 : this.state.time + 1;
      this.setState({ time });
    }, 200 );

    let timeout = false,
        delay = 100;

    window.onresize = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.onResize(this.getSize());
      }, delay);
    }

    this.onResize(this.getSize());

    // compute shares

  }

  convertTime = minutes => [(Math.floor(minutes / 60)) % 24, minutes % 60];
  formatTime = time =>
    this.convertTime(time).map((e, i) => ("0" + e).substr(-2)).join(':');

  handleSliderChange = (event, value) => this.setState({ time: value });

  selectCountry1 = (event) => this.setState({country1: event.target.value});
  selectCountry2 = (event) => this.setState({country2: event.target.value});

  toggleStopped = () => this.setState({ stopped: !this.state.stopped });
  onChangeColor = () => this.state.getColor === this.getColorBySex ?
    this.setState({ getColor: this.getColorByTarget, bySex: false}) :
    this.setState({ getColor: this.getColorBySex, bySex: true});

  toggleInfoDialog = () => this.setState({ infoDialog: !this.state.infoDialog });

  onResize = ([width, height]) => this.setState({
    width, height,
    targetPoints: this.createTargetPoints(width, height)
  });

  numFormat = lang => v => lang === 'HU' ? ('' + v).replace('.', ',') : v;

  render() {
    const { radius, nodes, time, country1, country2, stopped, getColor, bySex, width, height, targetPoints, text, lang, infoDialog } = this.state;
    const getLeft = time => time / 1439 * width * 2;
    return (
      <div className="App">
        <MuiThemeProvider theme={theme}>
        <div id="clock">{this.formatTime(time)}</div>
        <div id="select">
          <div>
            <CountrySelect
                  countries={text.countries}
                  country={country1}
                  handleChange={this.selectCountry1} />
          </div>
          <div>
            <CountrySelect
                countries={text.countries}
                country={country2}
                handleChange={this.selectCountry2} />
          </div>
        </div>
        <div id="compare">
          <div className="country" id="country1">
            <Canvas
              id="canvas1"
              time={time}
              nodes={nodes[country1]}
              radius={radius}
              targets={text.activities}
              targetPoints={targetPoints}
              width={width}
              height={height}
              getColor={getColor}
              bySex={bySex}
              numFormat={this.numFormat(lang)} />
          </div>
          <div className="country" id="country2">
            <Canvas
              id="canvas2"
              time={time}
              nodes={nodes[country2]}
              radius={radius}
              targets={text.activities}
              getColor={getColor}
              targetPoints={targetPoints}
              width={width}
              height={height}
              bySex={bySex}
              numFormat={this.numFormat(lang)} />
          </div>
        </div>
        <div id="ticks">
          <div style={{ left: 0 }} className="lowerLimit first" onClick={() => this.setState({time: 0})}>00:00</div>
          <div style={{ left: getLeft(6 * 60) }} className="lowerLimit middle" onClick={() => this.setState({time: 6 * 60})}>06:00</div>
          <div style={{ left: getLeft(12 * 60) }} className="lowerLimit middle" onClick={() => this.setState({time: 12 * 60})}>12:00</div>
          <div style={{ left: getLeft(18 * 60) }} className="lowerLimit middle" onClick={() => this.setState({time: 18 * 60})}>18:00</div>
          <div style={{ left: getLeft(24 * 60 - 1) }} className="upperLimit last" onClick={() => this.setState({time: 24 * 60 - 1})}>23:59</div>
        </div>
        <div id="sliderWrapper">
            <Slider
              style={{ paddingLeft: 0, paddingTop: '0.8em', margin: 0}}
                id="slider"
                min={0}
                max={1439}
                value={time}
                step={1}
                onChange={this.handleSliderChange} />
        </div>
        <div id="footer">
          <div>
            <Button variant="fab"
              color="primary"
              mini
              onClick={this.toggleStopped}>
              { stopped ? <PlayIcon /> : <PauseIcon /> }
            </Button>
            <span style={{ marginLeft: '2em', marginRight: '1em', fontSize: '80%'}}>{text.colors}</span>
            <FormControlLabel label={text.byTarget}
              control={<Radio
                checked={this.getColorByTarget === getColor}
                onChange={this.onChangeColor}
                color="primary" />} />
            <FormControlLabel label={text.bySex}
              control={<Radio
                checked={this.getColorBySex === getColor}
                onChange={this.onChangeColor}
                color="primary" />}/>
            <IconButton variant="fab"
              color="primary"
              onClick={this.toggleInfoDialog}>
                <InfoIcon />
            </IconButton>
            <InfoDialog text={text} handleClose={this.toggleInfoDialog} open={infoDialog}/>
          </div>
          <div id="title">{text.title}<img src={lang === 'HU' ? logo : logoEN} alt={text.KSH} id="logo" /></div>
        </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

function InfoDialog({ handleClose, open, text }) {
  return (
    <Dialog open={open}>
      <div className="infoDialog">
        {text.info}
        <Button variant="contained"
          className="closeButton"
          color="primary"
          onClick={handleClose}>{text.close}</Button>
      </div>
    </Dialog>
  );
}

function CountrySelect({ countries, country, handleChange }) {
  return (
    <Select
      className="countrySelect"
      value={country}
      onChange={handleChange}
    >
    { countries.map(e => <MenuItem key={e.code} value={e.code}>{e.name}</MenuItem>) }
    </Select>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js